module.exports = __webpack_public_path__ + "img/account_security_user.40613ad7.svg";